var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "helpResourceConfig" },
    [
      _c(
        "div",
        { staticClass: "leftBox" },
        [
          _c(
            "basic-container",
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v("帮助中心视频教程资源组")])]
                ),
                _c(
                  "div",
                  { staticClass: "clearfix" },
                  [
                    _c(
                      "avue-crud",
                      {
                        ref: "crud",
                        attrs: {
                          option: _vm.optionParent,
                          "table-loading": _vm.loading,
                          data: _vm.dataParent,
                          page: _vm.pageParent,
                          permission: _vm.permissionList,
                          "before-open": _vm.beforeOpen,
                        },
                        on: {
                          "row-del": _vm.rowDel,
                          "row-update": _vm.rowUpdate,
                          "row-save": _vm.rowSave,
                          "row-click": _vm.handleRowClick,
                          "search-change": _vm.searchChange,
                          "search-reset": _vm.searchReset,
                          "selection-change": _vm.selectionChange,
                          "current-change": _vm.currentChange,
                          "size-change": _vm.sizeChange,
                          "refresh-change": _vm.refreshChange,
                          "on-load": _vm.onLoadParent,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "isSealed",
                            fn: function ({ row }) {
                              return [
                                _c("el-tag", [
                                  _vm._v(
                                    _vm._s(row.isSealed === 0 ? "否" : "是")
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.formParent,
                          callback: function ($$v) {
                            _vm.formParent = $$v
                          },
                          expression: "formParent",
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "menuLeft" },
                          [
                            _vm.permission.dict_delete
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "danger",
                                      size: "small",
                                      icon: "el-icon-delete",
                                      plain: "",
                                    },
                                    on: { click: _vm.handleDelete },
                                  },
                                  [_vm._v("删 除\n              ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("dragAdjustWidth", { attrs: { wrapperBox: "helpResourceConfig" } }),
      _c(
        "div",
        { staticClass: "rightBox" },
        [
          _c(
            "basic-container",
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", [
                      _vm._v("[" + _vm._s(_vm.dictValue) + "] 资源配置"),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "clearfix" },
                  [
                    _c(
                      "avue-crud",
                      {
                        ref: "crudChild",
                        attrs: {
                          option: _vm.optionChild,
                          "table-loading": _vm.loadingChild,
                          data: _vm.dataChild,
                          permission: _vm.permissionList,
                          "before-open": _vm.beforeOpenChild,
                          "upload-before": _vm.uploadBefore,
                          "upload-error": _vm.uploadError,
                        },
                        on: {
                          "row-del": _vm.rowDelChild,
                          "row-update": _vm.rowUpdateChild,
                          "row-save": _vm.rowSaveChild,
                          "search-change": _vm.searchChangeChild,
                          "search-reset": _vm.searchResetChild,
                          "selection-change": _vm.selectionChangeChild,
                          "current-change": _vm.currentChangeChild,
                          "size-change": _vm.sizeChangeChild,
                          "refresh-change": _vm.refreshChangeChild,
                          "on-load": _vm.onLoadChild,
                          "sortable-change": _vm.sortableChildChange,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "icon",
                            fn: function ({ row }) {
                              return [
                                row.icon
                                  ? _c("el-image", {
                                      staticStyle: {
                                        width: "100px",
                                        height: "50px",
                                        cursor: "pointer",
                                      },
                                      attrs: { src: row.icon },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showImge(row.image)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "image",
                            fn: function ({ row }) {
                              return [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "100px",
                                    height: "50px",
                                    cursor: "pointer",
                                  },
                                  attrs: { src: row.image },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showImge(row.image)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "appidFilterList",
                            fn: function ({ row }) {
                              return [
                                row.appidFilterNames
                                  ? [
                                      row.appidFilterNames.split(";").length < 5
                                        ? _vm._l(
                                            row.appidFilterNames.split(";"),
                                            function (item, index) {
                                              return _c(
                                                "el-tag",
                                                { key: index },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(item) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          )
                                        : [
                                            _c("el-tag", [
                                              _vm._v(
                                                _vm._s(
                                                  row.appidFilterNames.split(
                                                    ";"
                                                  )[0]
                                                )
                                              ),
                                            ]),
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "right",
                                                  width: "400",
                                                  trigger: "click",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  _vm._l(
                                                    row.appidFilterNames.split(
                                                      ";"
                                                    ),
                                                    function (item, index) {
                                                      return _c(
                                                        "el-tag",
                                                        {
                                                          key: index,
                                                          attrs: {
                                                            size: "mini",
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(item))]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                                _c(
                                                  "el-tag",
                                                  {
                                                    staticClass:
                                                      "el-icon-right",
                                                    attrs: {
                                                      slot: "reference",
                                                      size: "mini",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [_vm._v("展开更多")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                    ]
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "eventType",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.dic.filter((item) =>
                                        [scope.row.eventType + ""].includes(
                                          item.dictKey
                                        )
                                      )[0].dictValue
                                    ) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                          {
                            key: "appidFilterListForm",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  attrs: { type: "textarea" },
                                  on: {
                                    focus: function ($event) {
                                      return _vm.handleClick()
                                    },
                                  },
                                  model: {
                                    value: _vm.formChild.appidFilterNames,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formChild,
                                        "appidFilterNames",
                                        $$v
                                      )
                                    },
                                    expression: "formChild.appidFilterNames",
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "isSealed",
                            fn: function ({ row }) {
                              return [
                                _c("el-tag", [
                                  _vm._v(
                                    _vm._s(row.isSealed === 0 ? "否" : "是")
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.formChild,
                          callback: function ($$v) {
                            _vm.formChild = $$v
                          },
                          expression: "formChild",
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "menuLeft" },
                          [
                            _vm.permission.dict_delete
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "danger",
                                      size: "small",
                                      icon: "el-icon-delete",
                                      plain: "",
                                    },
                                    on: { click: _vm.handleDeleteChild },
                                  },
                                  [_vm._v("删 除\n              ")]
                                )
                              : _vm._e(),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "拖动数据可以进行排序!",
                                  placement: "right",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "success",
                                      size: "small",
                                      icon: "el-icon-check",
                                    },
                                    on: { click: _vm.handleSaveSort },
                                  },
                                  [_vm._v("保存排序\n              ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
              _c("channel-popups", {
                attrs: {
                  "app-id": _vm.formChild.appidFilterList,
                  visible: _vm.activityForm.showPopups,
                },
                on: {
                  "update:visible": function ($event) {
                    return _vm.$set(_vm.activityForm, "showPopups", $event)
                  },
                  comfirm: _vm.handleConfirm,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }